import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doADHERENCE_SET} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_BATCH_ADHERENCE = 'REQUEST_BATCH_ADHERENCE'
export const doREQUEST_BATCH_ADHERENCE = createDoRequestAction(REQUEST_BATCH_ADHERENCE)

export const requestBatchAdherenceActionCreators = {
  doREQUEST_BATCH_ADHERENCE,
}

export function* requestBatchAdherence({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestBatchAdherence')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        batchId: v.string().uuid().exist(),
        startDate: v.date(),
        page: v.number().optional(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_BATCH_ADHERENCE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId, batchId, startDate, page} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/batch-adherence`,
    accessToken,
    data: {
      batchId,
      startDate,
      page,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_BATCH_ADHERENCE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/batch-adherence',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doADHERENCE_SET({
      projectId,
      batchId,
      ...result.payload,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_BATCH_ADHERENCE,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* batchAdherenceSaga() {
  yield takeEvery(REQUEST_BATCH_ADHERENCE, requestBatchAdherence)
}
